var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g({class:_vm.iconClasses},_vm.$listeners),[_c(_vm.iconComponent,_vm._b({tag:"component",staticClass:"jds-icon__svg",style:(_vm.svgStyles)},'component',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }